<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    @click:outside="close(false)"
    content-class="rounded-lg"
    scrollable
  >
    <v-card>
      <v-card-title>Lotes desabilitados no relatório</v-card-title>
      <v-card-text>
        <v-list dense>
          <v-list-item
            v-for="[id, ticketBlock] in hiddenTicketBlocks"
            :key="id"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ ticketBlocks.get(ticketBlock.id).TicketGroup.name }}
              </v-list-item-title>
              <v-list-item-title> {{ ticketBlock.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-alert v-if="loading" type="info" class="mt-3 mb-0" text>
          Atualizando relatório, por favor aguarde...
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close(false)">Fechar</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="close(true)" :loading="loading">
          Mostrar todos os lotes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    hiddenTicketBlocks: {
      type: Map,
      required: true,
    },
    ticketBlocks: {
      type: Map,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      resolve: null,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.loading = false;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    close(success = false) {
      if (!success) {
        this.dialog = false;
        this.resolve(success);
      } else {
        this.loading = true;
        setTimeout(() => {
          this.dialog = false;
          this.resolve(success);
        }, 10);
      }
    },
  },
};
</script>
